export const ADD_ACTION_NAME = 'Add';
export const EDIT_ACTION_NAME = 'Save Changes';
export const CANCEL_ACTION_NAME = 'Cancel';
export const ERROR_MESSAGE = 'Please enter all mandatory fields';
export const BREADCRUMBS_ROOT = 'Sites';
export const BREADCRUMBS_ALARM_RULES = 'Alarm Rules';
export const BREADCRUMBS_ADDFORM = 'Add Alarm Rule';
export const BREADCRUMBS_EDITFORM = 'Edit Alarm Rule: ';
export const LAST_EDITED_LABEL = 'Last edited on: ';
export const ADDITIONAL_CONDITION_LABEL = 'Additional Condition';
export const ALARM_INFO_LABEL = 'At least one of the limits needs to be entered.';
export const ADDITIONAL_CONDITION_ERROR = 'Please enter all fields for additional condition.';
export const DELETE_ACTION_NAME = 'Delete';
export const CONFIRM_ACTION_NAME = 'Confirm';
export const DEACTIVATE_ACTION_NAME = 'Deactivate';
export const DELETE_ALARM_RULE = 'Delete Alarm Rule';
export const ALARM_RULE_OPTIONS_TEXT =
  'Clicking "Delete" button will permanently delete current alarm rule.';
export const ALARM_RULE_OPTIONS_TITLE = 'Alarm rule options';
export const CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG = 'Are you sure you want to delete';
export const CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG_EXPLANATION =
  'Active alarms will be cleared. No further alarms will be generated for this rule. Historical alarm events will not be affected.';
export const CONFIRMATION_TEXT_DELETE_ALARM_EVENT =
  'Are you sure you want to delete this alarm event? The alarm event cannot be retrieved once it has been deleted.';

export const DELAY_OPTIONS = [
  '10 seconds',
  '30 seconds',
  '1 minute',
  '2 minutes',
  '5 minutes',
  '15 minutes',
];

export const SUCCESSFULL_MESSAGE_ADD_ALARM_RULE = 'Alarm rule created successfully';
export const SUCCESSFULL_MESSAGE_EDIT_ALARM_RULE = 'Alarm rule updated successfully';

export const TITLE = 'title';
export const PRIORITY = 'priority';
export const IS_ACTIVE = 'isActive';
export const DESCRIPTION = 'description';
